import React from 'react';
import PropTypes from 'prop-types';

const CheckboxIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="12" viewBox="0 0 14 12">
    <path fill="#000" fill-rule="nonzero" d="M12.465.022c.358-.063.683.01.974.219.291.208.47.485.538.83.067.344-.011.662-.235.954l-6.955 9.453a1.4 1.4 0 0 1-.857.5 1.213 1.213 0 0 1-.958-.219l-.103-.08c-.227-.189-.663-.606-1.308-1.25a113.924 113.924 0 0 1-2.15-2.207L.37 7.158A1.247 1.247 0 0 1 0 6.25c0-.354.134-.657.403-.907s.583-.37.94-.36c.308.009.574.113.799.314l3.435 3.457L11.625.522c.224-.27.504-.438.84-.5z"/>
  </svg>
);

CheckboxIcon.propTypes = {
  fill: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string
};

export default CheckboxIcon;
